/* =============================================================================
 * Delta Clothing — cart-wide stock validation
 *
 * Runs only on /cart. Validates the visible DraftOrder cart as one payload so
 * repeated S&S SKUs are compared against their combined requested quantity.
 * =============================================================================*/
(function () {
  if (!window.B2B || window.__dlc_cart_stock) return;
  if (!document.querySelector('[data-cart-section]') || !document.querySelector('[data-cart-footer-section]')) return;

  var CHECK_INTERVAL_MS = 30000;
  var inflight = null;
  var changeTimer = null;
  var lastResult = { can_checkout: true, issues: [] };

  function currentLines() {
    try {
      var cache = window.__dlc_bag && window.__dlc_bag.getCache && window.__dlc_bag.getCache();
      return Array.isArray(cache) ? cache : [];
    } catch (e) {
      return [];
    }
  }

  function requestLines(lines) {
    return (Array.isArray(lines) ? lines : []).filter(function (line) {
      return line && line.variant_id && (parseInt(line.quantity, 10) || 0) > 0;
    }).map(function (line) {
      return {
        line_id: line.line_id || null,
        variant_id: line.variant_id,
        sku: line.sku || null,
        title: line.title || null,
        quantity: parseInt(line.quantity, 10) || 0,
        properties: line.custom || {}
      };
    });
  }

  function issueText(issue) {
    if (!issue || issue.code === 'stock_unavailable') return 'Stock could not be verified.';
    if (issue.code === 'out_of_stock') return 'Out of stock.';
    return 'Only ' + String(issue.available || 0) + ' available.';
  }

  function issueDetail(issue) {
    var requested = String((issue && issue.requested) || 0);
    if (!issue || issue.code === 'stock_unavailable') {
      return 'Stock could not be verified (requested ' + requested + '; available unknown).';
    }
    if (issue.code === 'out_of_stock') {
      return 'Out of stock (requested ' + requested + '; available 0).';
    }
    return 'Only ' + String(issue.available || 0) + ' available (requested ' + requested + ').';
  }

  function issueLabel(issue) {
    var options = [issue.color, issue.size].filter(Boolean).join(' / ');
    var label = issue.title || issue.sku || 'Cart item';
    if (options) label += ' — ' + options;
    return label + ': ' + issueDetail(issue);
  }

  function findLine(lineId) {
    if (!lineId) return null;
    var rows = document.querySelectorAll('.b2b-cart__item[data-line]');
    for (var i = 0; i < rows.length; i += 1) {
      if (String(rows[i].getAttribute('data-line') || '') === String(lineId)) return rows[i];
    }
    return null;
  }

  function clearLineState() {
    document.querySelectorAll('.b2b-cart__item--stock-issue').forEach(function (row) {
      row.classList.remove('b2b-cart__item--stock-issue');
    });
    document.querySelectorAll('[data-cart-stock-message]').forEach(function (message) {
      message.hidden = true;
      message.textContent = '';
    });
  }

  function paintCheckout(blocked) {
    document.querySelectorAll('[data-checkout-href]').forEach(function (checkout) {
      checkout.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      checkout.classList.toggle('b2b-cart__checkout--stock-blocked', blocked);
      if (blocked) checkout.setAttribute('data-stock-blocked', 'true');
      else checkout.removeAttribute('data-stock-blocked');
    });
  }

  function paintWarning(result) {
    var warning = document.querySelector('[data-cart-stock-warning]');
    if (!warning) return;

    warning.textContent = '';
    if (result.can_checkout) {
      warning.style.display = 'none';
      return;
    }

    var title = document.createElement('p');
    title.className = 'b2b-cart__stock-warning-title';
    title.textContent = result.check_failed
      ? 'We could not verify your cart stock. Please try again.'
      : 'Some items in your cart need attention before checkout.';
    warning.appendChild(title);

    if (Array.isArray(result.issues) && result.issues.length) {
      var list = document.createElement('ul');
      list.className = 'b2b-cart__stock-warning-list';
      result.issues.forEach(function (issue) {
        var item = document.createElement('li');
        item.textContent = issueLabel(issue);
        list.appendChild(item);
      });
      warning.appendChild(list);
    }

    warning.style.display = 'block';
  }

  function applyResult(result) {
    result = result && typeof result.can_checkout === 'boolean'
      ? result
      : { can_checkout: false, issues: [], check_failed: true };
    result.issues = Array.isArray(result.issues) ? result.issues : [];
    lastResult = result;

    clearLineState();
    result.issues.forEach(function (issue) {
      var row = findLine(issue.line_id);
      if (!row) return;
      row.classList.add('b2b-cart__item--stock-issue');
      var message = row.querySelector('[data-cart-stock-message]');
      if (message) {
        message.hidden = false;
        message.textContent = issueText(issue);
      }
    });

    paintWarning(result);
    paintCheckout(!result.can_checkout);
    try { window.dispatchEvent(new CustomEvent('dlc:cart-stock-updated', { detail: result })); } catch (e) {}
    return result;
  }

  function runCheck(lines) {
    var payload = requestLines(lines);
    if (!payload.length) {
      return Promise.resolve(applyResult({ can_checkout: true, issues: [], checked_at: new Date().toISOString() }));
    }

    return window.B2B.postJSON(window.B2B.endpoints.cartStock, {
      customer_id: window.B2B.getCustomerGid(),
      lines: payload
    }, { timeoutMs: 15000 }).then(function (result) {
      if (!result || typeof result.can_checkout !== 'boolean') throw new Error('Invalid cart stock response');
      return applyResult(result);
    });
  }

  function check(forceBagRefresh) {
    if (inflight) return inflight;

    var linesPromise = Promise.resolve(currentLines());
    if (window.__dlc_bag && typeof window.__dlc_bag.load === 'function' && (forceBagRefresh || !currentLines().length)) {
      linesPromise = window.__dlc_bag.load(!!forceBagRefresh);
    }

    inflight = linesPromise
      .then(runCheck)
      .catch(function (error) {
        console.error('[dlc-stock] check failed:', error);
        return applyResult({ can_checkout: false, issues: [], check_failed: true });
      })
      .finally(function () { inflight = null; });

    return inflight;
  }

  function focusWarning() {
    var warning = document.querySelector('[data-cart-stock-warning]');
    if (!warning || warning.style.display === 'none') return;
    try { warning.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    try { warning.focus({ preventScroll: true }); } catch (e) {}
  }

  window.__dlc_cart_stock = {
    check: check,
    applyResult: applyResult,
    hasIssues: function () { return !lastResult.can_checkout; },
    current: function () { return lastResult; },
    focusWarning: focusWarning
  };

  window.addEventListener('dlc:cart-changed', function () {
    if (changeTimer) clearTimeout(changeTimer);
    changeTimer = setTimeout(function () { check(true); }, 75);
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) check(true);
  });

  function init() {
    check(true);
    setInterval(function () {
      if (!document.hidden) check(false);
    }, CHECK_INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    setTimeout(init, 0);
  }
})();
